import { CreateEnrollmentType } from "../../../types/Student";
import { put } from "../../../utils/axios-config";
import { ENROLLMENTS } from "../../../utils/constants";


export const updateEnrollment = async (data: CreateEnrollmentType) => await put<CreateEnrollmentType, string>(ENROLLMENTS, data);